import { inject, Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class SessionSync {
  private router = inject(Router);
  private zone = inject(NgZone);
  private started = false;

  init(): void {
    if (this.started) return;
    this.started = true;

    window.addEventListener('storage', (e: StorageEvent) => {
      if (e.storageArea !== localStorage) return;
      const loggedOut = e.key === null || (e.key === 'accessToken' && !e.newValue);
      const loggedIn = e.key === 'accessToken' && !!e.newValue && !e.oldValue;
      const lang = localStorage.getItem('selectedLanguage') || 'en';
      this.zone.run(() => {
        if (loggedOut && !this.router.url.includes('/LOGIN')) {
          this.router.navigate(['/', lang, 'LOGIN']);
        } else if (loggedIn && this.router.url.includes('/LOGIN')) {
          this.router.navigate(['/', lang, 'student', 'dashboard']);
        }
      });
    });
  }
}
